import { useMemo } from "react";
import { SECTION_FOUR_CREATE_ORG_REQUIRED_HINT } from "@/entities/journal/model/section-four-access-messages";
import type { TitleJournalOrgCheckInput } from "@/entities/journal/model/title-journal-org-check.types";
import { userHasOrganizationOnTitlePage } from "@/entities/journal/model/user-has-organization-on-title-page";
import { useLocalStorage } from "@/shared/lib/hooks";

export function useCanCreateSectionFourRecord(
  titleJournal: TitleJournalOrgCheckInput,
  isTitleLoading: boolean,
  signersCount: number,
) {
  const [newToken] = useLocalStorage("newToken");

  return useMemo(() => {
    const isTitleReady = !isTitleLoading && Boolean(titleJournal);
    const hasOrgOnTitlePage = isTitleReady
      ? userHasOrganizationOnTitlePage(titleJournal, newToken)
      : true;
    const hasSigners = signersCount > 0;
    const isAddDisabled = !hasSigners || !hasOrgOnTitlePage;
    const isAddDisabledByMissingOrg = isTitleReady && !hasOrgOnTitlePage;
    const addButtonTooltip = isAddDisabledByMissingOrg
      ? SECTION_FOUR_CREATE_ORG_REQUIRED_HINT
      : undefined;

    return {
      hasOrgOnTitlePage,
      isAddDisabled,
      isAddDisabledByMissingOrg,
      addButtonTooltip,
      canOpenCreateForm: hasSigners && hasOrgOnTitlePage,
    };
  }, [titleJournal, isTitleLoading, signersCount, newToken]);
}
